import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_EquipmentSkeleton = _resolveComponent("EquipmentSkeleton")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ContentSidebarWrapper = _resolveComponent("ContentSidebarWrapper")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { color: "primary" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: _ctx.$t('report_sheets.steps_page.back_button_label'),
                    "default-href": "/report-sheets"
                  }, null, 8, ["text"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('report_sheets.top_bar.title')) + " : " + _toDisplayString(_ctx.sheet?.title ?? _ctx.$t('report_sheets.top_bar.loading')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ContentSidebarWrapper, { side: "left" }, _createSlots({
            content: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_EquipmentSkeleton)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_ion_item, {
                      button: true,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`/report-sheets/${_ctx.sheet?.uuid}/annexes/${_ctx.sheet?.annexes[0]?.uuid}`)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style['inner'])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.annexes.title')), 1)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style['right'])
                          }, [
                            (!_ctx.sheet?.annexes_step_validated)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.pending')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.sheet?.annexes_step_validated)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 1,
                                  class: _normalizeClass(_ctx.$style['step-validated'])
                                }, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.validated')), 3))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      button: true,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/report-sheets/${_ctx.sheet?.uuid}/equipments`)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style['inner'])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.materials.title')) + " (" + _toDisplayString(_ctx.sheet?.equipments.length) + ")", 1),
                            (_ctx.sheet?.total_equipments_cost)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Coût total : " + _toDisplayString(_ctx.sheet.total_equipments_cost) + "€", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style['right'])
                          }, [
                            (_ctx.sheet?.equipments_step_validated)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: _normalizeClass(_ctx.$style['step-validated'])
                                }, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.validated')), 3))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      button: true,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/report-sheets/${_ctx.sheet?.uuid}/locations`)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style['inner'])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.locations.title')) + " (" + _toDisplayString(_ctx.sheet?.locations.length) + ")", 1),
                            (_ctx.sheet?.total_locations_cost)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Coût total : " + _toDisplayString(_ctx.sheet.total_locations_cost) + "€", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style['right'])
                          }, [
                            (_ctx.sheet?.locations_step_validated)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: _normalizeClass(_ctx.$style['step-validated'])
                                }, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.validated')), 3))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      button: true,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push(`/report-sheets/${_ctx.sheet?.uuid}/outsourced-works`)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style['inner'])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.outsourced_works.title')) + " (" + _toDisplayString(_ctx.sheet?.outsourced_works.length) + ")", 1),
                            (_ctx.sheet?.total_outsourced_work_cost)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Coût total : " + _toDisplayString(_ctx.sheet.total_outsourced_work_cost) + "€", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style['right'])
                          }, [
                            (_ctx.sheet?.outsourced_work_step_validated)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: _normalizeClass(_ctx.$style['step-validated'])
                                }, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.validated')), 3))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      button: true,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push(`/report-sheets/${_ctx.sheet?.uuid}/employees`)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style['inner'])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.employees.title')) + " (" + _toDisplayString(_ctx.sheet?.employees.length) + ")", 1),
                            (_ctx.sheet?.total_employees_cost)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Coût total : " + _toDisplayString(_ctx.sheet.total_employees_cost) + "€", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.$style['right'])
                          }, [
                            (_ctx.sheet?.employees_step_validated)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 0,
                                  class: _normalizeClass(_ctx.$style['step-validated'])
                                }, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.validated')), 3))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      button: true,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push(`/report-sheets/${_ctx.sheet?.uuid}/summary`)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$style['inner'])
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('report_sheets.steps_page.steps.resume.title')), 1)
                          ])
                        ], 2)
                      ]),
                      _: 1
                    }),
                    (_ctx.canBeValidatedBySiteSupervisor || _ctx.canBeValidatedBySiteManager || _ctx.canBeValidatedByManager)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(_ctx.$style['container-button-remove-employee'])
                        }, [
                          _createVNode(_component_ion_button, {
                            onClick: _ctx.presentActionSheet,
                            slot: "end"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Valider ce rapport "),
                              _createVNode(_component_ion_icon, {
                                class: _normalizeClass(_ctx.$style['icon-remove-employee']),
                                icon: _ctx.checkmarkOutline
                              }, null, 8, ["class", "icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _: 2
          }, [
            (!_ctx.loading && _ctx.sheet?.total_cost )
              ? {
                  name: "sidebar",
                  fn: _withCtx(() => [
                    _createElementVNode("p", {
                      class: _normalizeClass(_ctx.$style['total_day'])
                    }, "Coût total : " + _toDisplayString(_ctx.sheet?.total_cost ?? 0.00) + "€", 3)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}